import * as materials from "materials/legacy/legacy-fire";
export { materials };
export default materials;
